import { render, staticRenderFns } from "./canvas-integration-form.vue?vue&type=template&id=22696d52&scoped=true&"
import script from "./canvas-integration-form.vue?vue&type=script&lang=js&"
export * from "./canvas-integration-form.vue?vue&type=script&lang=js&"
import style0 from "./canvas-integration-form.vue?vue&type=style&index=0&id=22696d52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22696d52",
  null
  
)

export default component.exports